export const USER_PROFILE = "user/profile";
export const UPLOAD_FILE = "file/upload";
